import { render, staticRenderFns } from "./AlertPanel.vue?vue&type=template&id=05d55d85&scoped=true"
import script from "./AlertPanel.vue?vue&type=script&lang=js"
export * from "./AlertPanel.vue?vue&type=script&lang=js"
import style0 from "./AlertPanel.vue?vue&type=style&index=0&id=05d55d85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d55d85",
  null
  
)

export default component.exports